<template>
  <component :is="bgComponent" />
</template>
<script>

import UIMixin from "@/mixins/UIMixin";
import DefaultBackground from "./DefaultBackground.vue";
import GradientBackground from "./GradientBackground.vue";
import WavesBackground from "./WavesBackground.vue";
import LightsBackground from "./LightsBackground.vue";

export default{
  name: 'Background',
  components: {
    DefaultBackground,
    GradientBackground,
    WavesBackground,
    LightsBackground,
  },
  mixins: [ UIMixin ]
}
</script>
<style scoped lang="scss">

</style>
